import styled from 'styled-components';

export const Container = styled.div`
  .modal-header.dark-bg {
    background: ${(props) => props.theme.$steel_blue};
    border-radius: 0;
    padding: 16px;
  }

  .chatbot {
    height: 80vh;
    display: flex;
    flex-direction: column;

    &-body {
      position: relative;
      flex: 1;
    }

    &-messages {
      position: absolute;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      scrollbar-color: ${(props) => props.theme.$gray600} ${(props) => props.theme.$white};
      scrollbar-width: thin;
    }

    &-form {
      position: sticky;
      bottom: 0;

      .chatbot-input-group {
        width: 100%;
        display: flex;
      }

      .btn-chatbot-audio {
        display: flex;
        align-items: center;
      }

      .chatbot-audio-control {
        display: flex;
        align-items: center;
      }

      .btn-chatbot-send {
        background: ${(props) => props.theme.$info};
        color: ${(props) => props.theme.$white};
        border-radius: 0 4px 4px 0;

        &:disabled {
          cursor: default;
        }
      }
    }

    &-input {
      width: calc(100% - 40px);
      border-radius: 4px 0 0 4px;
      padding: 5px 15px;
      display: flex;
      align-items: center;
      overflow-y: auto;
      overflow-x: hidden;
      word-break: break-word;
      outline: none;
      scrollbar-color: ${(props) => props.theme.$info} ${(props) => props.theme.$white};
      scrollbar-width: thin;

      &:empty::before,
      &:has(br:only-child)::before {
        content: 'Digite uma mensagem';
        color: ${(props) => props.theme.$gray400};
      }

      &:not(:empty)::before {
        content: '';
      }

      &[contentEditable='true']:focus {
        &::before {
          content: '';
        }
      }

      &-group {
        min-height: 51px;
        max-height: 85px;
        border: 1px solid ${(props) => props.theme.$gray400};
        border-radius: 4px;
      }

      &[contentEditable='false'] {
        opacity: 0.5;
      }
    }

    &-notice {
      color: ${(props) => props.theme.$black}90;
      font-size: 0.8rem;
    }
  }

  .message {
    &-box {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      padding: 16px 20px;
    }

    &-text {
      word-break: break-word;
      line-height: 1.6;

      p {
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .chat-actions {
    display: flex;
    gap: 12px;
    padding: 12px 20px;

    .btn-action {
      flex: 1;
      padding: 10px 16px;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s;

      &:disabled {
        opacity: 0.6;
        cursor: default;
      }
    }

    .btn-clear {
      background: #fff;
      border: 1px solid #ced4da;
      color: #495057;

      &:hover:not(:disabled) {
        background: #f1f3f5;
      }
    }

    .btn-save {
      background: #fff;
      border: 1px solid #007bff;
      color: #007bff;

      &:hover:not(:disabled) {
        background: #e7f1ff;
      }
    }

    .btn-apply {
      background: #007bff;
      border: 1px solid #007bff;
      color: #fff;

      &:hover:not(:disabled) {
        background: #0069d9;
      }
    }
  }

  .assistant {
    background: ${(props) => props.theme.$gray200};
  }

  .ia {
    border: 1px solid transparent;
    padding: 6px 12px;
    font-size: 16px;
    background: linear-gradient(90deg, #007bff, #009f79) padding-box,
      linear-gradient(90deg, #007bff, #009f79) border-box;
  }
`;
